module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-04.1262baa0.svg";